<div class="container-fluid p-0">

  <div class="card rounded-0">
    <div class="card-body">

      <div class="row m-0 mb-1">
        <div class="col-2 p-0">
          <div class="px-3 py-2">
            <mat-form-field *ngIf="ta_revised.parent" class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Version:</mat-label>
              <mat-select [(ngModel)]="ta_revised_view.id" (ngModelChange)="find(ta_revised_view.id, true)" name="version_no" aria-label="Select the version of the {{ utils.getLangTerm('ta-jsa-swms.singular', 'TA/JSA/SWMS') }} you want to view.">
                <mat-option *ngFor="let ta_children of ta_revised.parent.children" [value]="ta_children.id">{{ ta_children.version_no }}</mat-option>
                <mat-option [value]="ta_revised.parent.id">1</mat-option>
              </mat-select>
            </mat-form-field>
            <ng-container *ngIf="!ta_revised.parent">
              <h6>Version</h6>
              <p>1</p>
            </ng-container>
          </div>
        </div>
        <div class="col text-center text-lg-right">
          <button
            type="button"
            *ngIf="app.user.id == approverId && canEdit"
            [disabled]="!isLatestVersion || approverAcknowledged || inProgress"
            mat-raised-button
            (click)="onOpenDigitalSignaturePad('approver')"
            class="mx-2 ml-lg-3 mr-lg-0 my-2 mat-success">
            <mat-icon>check_circle</mat-icon>
            {{ approverAcknowledged ? 'Approved' : 'Approve' }}
          </button>

          <button
            type="button"
            *ngIf="app.user.id == authorizerId && canEdit"
            [disabled]="!isLatestVersion || authorizerAcknowledged || inProgress"
            mat-raised-button
            (click)="onOpenDigitalSignaturePad('authorizer')"
            class="mx-2 ml-lg-3 mr-lg-0 my-2 mat-success">
            <mat-icon>check_circle</mat-icon>
            {{ authorizerAcknowledged ? 'Authorized' : 'Authorize' }}
          </button>

          <button
            type="button"
            *ngIf="app.user.id == supervisorId && canEdit"
            [disabled]="!isLatestVersion || supervisorAcknowledged || inProgress"
            mat-raised-button
            (click)="onOpenDigitalSignaturePad('supervisor')"
            class="mx-2 ml-lg-3 mr-lg-0 my-2 mat-success">
            <mat-icon>check_circle</mat-icon>
            Supervisor {{ supervisorAcknowledged ? 'Acknowledged' : 'Acknowledge' }}
          </button>

          <button
            type="button"
            *ngIf="utils.getSiteTAUserCheck(users, app.user.id) && signOffRolesAcknowledged() && canEdit"
            [disabled]="!isLatestVersion || !utils.getSiteTAUserStatusRequired(users, app.user.id) || acknowledgeUserId > 0 || inProgress"
            mat-raised-button
            (click)="onOpenDigitalSignaturePad('user')"
            class="mx-2 ml-lg-3 mr-lg-0 my-2 mat-success">
            <mat-icon>check_circle</mat-icon>
            {{ !utils.getSiteTAUserStatusRequired(users, app.user.id) || acknowledgeUserId > 0 ? 'Acknowledged' : 'Acknowledge' }}
          </button>
        </div>
      </div>

      <div class="horizontal-scroll-con">
        <div class="row m-0 mb-1" style="min-width: 1100px">
          <div class="col p-0">
            <div class="px-3 py-2">

              <section class="jumbotron py-4">
                  <h4 class="white-space-pre-wrap">{{ utils.getLangTerm('ta-jsa-swms.singular', 'TA/JSA/SWMS') }} - {{ ta_revised_view.task_name }}</h4><br />

                  <h4>{{ utils.getLangTerm('ta-jsa-swms.fields.task_description.label', 'Description') }}</h4>
                  <p class="white-space-pre-wrap">{{ ta_revised_view.task_description }}</p>

                  <ng-container *ngIf="ta_revised_view.work_procedure">
                    <hr class="my-4">
                    <h4>{{ utils.getLangTerm('ta-jsa-swms.fields.work_procedure.label', 'Work Procedure') }}</h4>
                    <p class="white-space-pre-wrap">{{ ta_revised_view.work_procedure }}</p>
                  </ng-container>
              </section>

              <ng-container>
                <table class="table table-bordered">
                  <thead class="thead-dark">
                    <tr class="text-center">
                      <th scope="col" style="width: 10%">ID #</th>
                      <th scope="col" style="width: 10%">Version #</th>
                      <th scope="col" style="width: 25%">Task</th>
                      <th scope="col" style="width: 35%">{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}</th>
                      <th scope="col" style="width: 20%">{{ utils.getLangTerm('contractors.singular', 'Contractor') }} Co</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-center">
                      <td style="width: 10%">{{ ta_revised_view.id }}</td>
                      <td style="width: 10%">{{ ta_revised_view.version_no ? ta_revised_view.version_no : 1 }}</td>
                      <td style="width: 25%">{{ ta_revised_view.task_name }}</td>
                      <td style="width: 35%">{{ ta_revised_view.site ? ta_revised_view.site.location : '' }}</td>
                      <td style="width: 20%">{{ ta_revised_view.contractor ? ta_revised_view.contractor.name : '' }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.amendment_title || ta_revised_view.reason_for_amendment">
                <table class="table table-bordered">
                  <thead class="thead-dark">
                    <tr class="text-center">
                      <th scope="col" style="width: 30%">Amendment Title</th>
                      <th scope="col" style="width: 70%">Reason for Amendment</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-center">
                      <td style="width: 30%">{{ ta_revised_view.amendment_title }}</td>
                      <td style="width: 70%">{{ ta_revised_view.reason_for_amendment }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.created_by_user">
                <table class="table table-bordered" style="max-width: 700px">
                  <thead class="thead-dark">
                    <tr class="text-center">
                      <th scope="col" style="width: 20%">User ID #</th>
                      <th scope="col" style="width: 40%">Created By</th>
                      <th scope="col" style="width: 40%">Created Date</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-center">
                      <td style="width: 20%">{{ ta_revised_view.created_by_user.id }}</td>
                      <td style="width: 40%">
                        <a (click)="onUserPublicView(ta_revised_view.created_by_user.hash)"
                           matTooltip="View User Public Profile">
                          {{ ta_revised_view.created_by_user.contact_person }}
                        </a>
                      </td>
                      <td style="width: 40%">{{ ta_revised_view.date_created ? (( ta_revised_view.date_created * 1000) | timezoneConvertMedium) : '' }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.updated_by_user">
                <table class="table table-bordered" style="max-width: 700px">
                  <thead class="thead-dark">
                    <tr class="text-center">
                      <th scope="col" style="width: 20%">User ID #</th>
                      <th scope="col" style="width: 40%">Last Updated By</th>
                      <th scope="col" style="width: 40%">Last Updated At</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-center">
                      <td style="width: 20%">{{ ta_revised_view.updated_by_user.id }}</td>
                      <td style="width: 40%">
                        <a (click)="onUserPublicView(ta_revised_view.updated_by_user.hash)"
                           matTooltip="View User Public Profile">
                          {{ ta_revised_view.updated_by_user.contact_person }}
                        </a>
                      </td>
                      <td style="width: 40%">{{ ta_revised_view.date_modified ? (( ta_revised_view.date_modified * 1000) | timezoneConvertMedium) : '' }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <h4 class="mt-5 mb-4">Authorisation</h4>

              <ng-container *ngIf="ta_revised_view.approver">
                <table class="table table-bordered">
                  <thead class="thead-dark">
                    <tr class="text-left">
                      <th scope="col" style="width: 10%">User ID #</th>
                      <th scope="col" style="width: 35%">Company</th>
                      <th scope="col" style="width: 15%">Approved By</th>
                      <th scope="col" style="width: 12%">Approved</th>
                      <th scope="col" style="width: 10%" *ngIf="ta_revised_view.approver_signature_url">Approver Signature</th>
                      <th scope="col" style="width: 15%">Approved Date</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-left">
                      <td style="width: 10%">{{ ta_revised_view.approver.id }}</td>
                      <td style="width: 35%">
                          <div *ngFor="let account of ta_revised_view.approver.accounts">
                            <span *ngIf="account.id == ta_revised_view.approver.account_id">{{ account.name }}</span>
                          </div>
                      </td>
                      <td style="width: 15%">
                        <a (click)="onUserPublicView(ta_revised_view.approver.hash)"
                           matTooltip="View User Public Profile">
                          {{ ta_revised_view.approver.contact_person }}
                        </a>
                      </td>
                      <td style="width: 12%">
                        <span *ngIf="ta_revised_view.approver_acknowledged" style="color: green">Yes</span>
                        <span *ngIf="!ta_revised_view.approver_acknowledged" style="color: red">No</span>
                      </td>
                      <td style="width: 10%" *ngIf="ta_revised_view.approver_signature_url">
                        <img style="width: 100px" [src]="ta_revised_view.approver_signature_url" [alt]="'Signature of ' + ta_revised_view.approver.contact_person" class="uploaded-image" />
                      </td>
                      <td style="width: 15%">{{ ta_revised_view.approver_acknowledged_date ? (( ta_revised_view.approver_acknowledged_date * 1000) | timezoneConvertMedium) : '' }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.authorizer">
                <table class="table table-bordered">
                  <thead class="thead-dark">
                  <tr class="text-left">
                    <th scope="col" style="width: 10%">User ID #</th>
                    <th scope="col" style="width: 35%">Company</th>
                    <th scope="col" style="width: 15%">Authorized By</th>
                    <th scope="col" style="width: 12%">Authorized</th>
                    <th scope="col" style="width: 10%" *ngIf="ta_revised_view.authorizer_signature_url">Authorizer Signature</th>
                    <th scope="col" style="width: 15%">Authorized Date</th>
                  </tr>
                  </thead>
                  <tbody class="bg-white">
                  <tr class="text-left">
                    <td style="width: 10%">{{ ta_revised_view.authorizer.id }}</td>
                    <td style="width: 35%">
                      <div *ngFor="let account of ta_revised_view.authorizer.accounts">
                        <span *ngIf="account.id == ta_revised_view.authorizer.account_id">{{ account.name }}</span>
                      </div>
                    </td>
                    <td style="width: 15%">
                      <a (click)="onUserPublicView(ta_revised_view.authorizer.hash)"
                         matTooltip="View User Public Profile">
                        {{ ta_revised_view.authorizer.contact_person }}
                      </a>
                    </td>
                    <td style="width: 12%">
                      <span *ngIf="ta_revised_view.authorizer_acknowledged" style="color: green">Yes</span>
                      <span *ngIf="!ta_revised_view.authorizer_acknowledged" style="color: red">No</span>
                    </td>
                    <td style="width: 10%" *ngIf="ta_revised_view.authorizer_signature_url">
                      <img style="width: 100px" [src]="ta_revised_view.authorizer_signature_url" [alt]="'Signature of ' + ta_revised_view.authorizer.contact_person" class="uploaded-image" />
                    </td>
                    <td style="width: 15%">{{ ta_revised_view.authorizer_acknowledged_date ? (( ta_revised_view.authorizer_acknowledged_date * 1000) | timezoneConvertMedium) : '' }}</td>
                  </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.supervisor">
                <table class="table table-bordered">
                  <thead class="thead-dark">
                  <tr class="text-left">
                    <th scope="col" style="width: 10%">User ID #</th>
                    <th scope="col" style="width: 35%">Company</th>
                    <th scope="col" style="width: 15%">Supervised By</th>
                    <th scope="col" style="width: 12%">Acknowledged</th>
                    <th scope="col" style="width: 10%" *ngIf="ta_revised_view.supervisor_signature_url">Supervisor Signature</th>
                    <th scope="col" style="width: 15%">Acknowledged Date</th>
                  </tr>
                  </thead>
                  <tbody class="bg-white">
                  <tr class="text-left">
                    <td style="width: 10%">{{ ta_revised_view.supervisor.id }}</td>
                    <td style="width: 35%">
                      <div *ngFor="let account of ta_revised_view.supervisor.accounts">
                        <span *ngIf="account.id == ta_revised_view.supervisor.account_id">{{ account.name }}</span>
                      </div>
                    </td>
                    <td style="width: 15%">
                      <a (click)="onUserPublicView(ta_revised_view.supervisor.hash)"
                         matTooltip="View User Public Profile">
                        {{ ta_revised_view.supervisor.contact_person }}
                      </a>
                    </td>
                    <td style="width: 12%">
                      <span *ngIf="ta_revised_view.supervisor_acknowledged" style="color: green">Yes</span>
                      <span *ngIf="!ta_revised_view.supervisor_acknowledged" style="color: red">No</span>
                    </td>
                    <td style="width: 10%" *ngIf="ta_revised_view.supervisor_signature_url">
                      <img style="width: 100px" [src]="ta_revised_view.supervisor_signature_url" [alt]="'Signature of ' + ta_revised_view.supervisor.contact_person" class="uploaded-image" />
                    </td>
                    <td style="width: 15%">{{ ta_revised_view.supervisor_acknowledged_date ? (( ta_revised_view.supervisor_acknowledged_date * 1000) | timezoneConvertMedium) : '' }}</td>
                  </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.files?.length">
                <h4 class="mt-5 mb-4">Files</h4>

                <table class="table table-bordered" style="max-width: 700px">
                  <thead class="thead-dark">
                    <tr class="text-left">
                      <th scope="col" style="width: 100%">Files</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-left">
                      <td style="width: 100%">
                        <app-files-list [view]="true" [files]="ta_revised_view.files"></app-files-list>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.workflows?.length">
                <h4 class="mt-5 mb-4">{{ utils.getLangTerm('ta-jsa-swms.fields.workflow_tab.label', 'Workflow') }}</h4>

                <table class="table table-bordered">
                  <thead class="thead-dark">
                  <tr class="text-left">
                    <th scope="col" style="width: 10%">WS ID #</th>
                    <th scope="col" style="width: 90%">&nbsp;</th>
                  </tr>
                  </thead>
                  <tbody class="bg-white">
                  <tr *ngFor="let workflow of ta_revised_view.workflows" class="text-left">
                    <td style="width: 10%;vertical-align:top;padding-top: 25px;">{{ workflow.id }}</td>
                    <td style="width: 90%">

                      <table class="table table-bordered">
                        <thead class="thead-light">
                          <tr class="text-left">
                            <th scope="col" style="width: 10%">Step No</th>
                            <th scope="col" style="width: 30%">Step</th>
                            <th scope="col" style="width: 15%">Created By</th>
                            <th scope="col" style="width: 15%">Created At</th>
                            <th scope="col" style="width: 15%">Last Updated By</th>
                            <th scope="col" style="width: 15%">Last Updated At</th>
                          </tr>
                        </thead>
                        <tbody class="bg-white">
                          <tr class="text-left">
                            <td style="width: 10%;">{{ workflow.step_no }}</td>
                            <td style="width: 30%;">{{ workflow.description }}</td>
                            <td style="width: 15%;">
                              <span *ngIf="workflow.created_by_user">
                                <a (click)="onUserPublicView(workflow.created_by_user.hash)"
                                   matTooltip="View User Public Profile">
                                  {{ workflow.created_by_user.contact_person }}
                                </a>
                              </span>
                            </td>
                            <td style="width: 15%;">{{ workflow.date_created ? (( workflow.date_created * 1000) | timezoneConvertMedium) : '' }}</td>
                            <td style="width: 15%;">
                              <span *ngIf="workflow.updated_by_user">
                                <a (click)="onUserPublicView(workflow.updated_by_user.hash)"
                                   matTooltip="View User Public Profile">
                                  {{ workflow.updated_by_user.contact_person }}
                                </a>
                              </span>
                            </td>
                            <td style="width: 15%;">{{ workflow.date_modified ? (( workflow.date_modified * 1000) | timezoneConvertMedium) : '' }}</td>
                          </tr>
                        </tbody>
                      </table>

                      <ng-container *ngIf="workflow.step_hazards?.length">
                        <table class="table table-bordered hazards-table">
                          <thead class="thead-light">
                          <tr class="text-left">
                            <th scope="col" style="width: 10%">ID #</th>
                            <th scope="col" style="width: 30%">Hazards/Risks</th>
                            <th scope="col" style="width: 10%">Significant</th>
                            <th scope="col" style="width: 12%">Last Review Date</th>
                            <th scope="col" style="width: 10%">Review Date</th>
                            <th scope="col" style="width: 7%">IRA Score</th>
                            <th scope="col" style="width: 7%">IRA</th>
                            <th scope="col" style="width: 7%">RRA Score</th>
                            <th scope="col" style="width: 7%">RRA</th>
                          </tr>
                          </thead>
                          <tbody class="bg-white">
                            <ng-container *ngFor="let hazard of workflow.step_hazards">
                              <tr class="text-left">
                                <td style="width: 10%">{{ hazard.id }}</td>
                                <td style="width: 30%">{{ hazard.name }}</td>
                                <td style="width: 10%">{{ hazard.significant ? 'Yes' : 'No' }}</td>
                                <td style="width: 12%">{{ hazard.last_reviewer_date ? (hazard.last_reviewer_date * 1000 | timezoneConvertMedium) : '' }}</td>
                                <td style="width: 10%">{{ hazard.reviewer_date ? (hazard.reviewer_date * 1000 | timezoneConvertMedium) : '' }}</td>
                                <td style="width: 7%">
                                  <span [class]="utils.getSiteRiskStatusTextColor(hazard.ira_score_band ?? utils.getRiskAssessmentText(hazard.ira_likelihood, hazard.ira_severity))">
                                    {{ hazard.ira_score ?? utils.calculateRiskScore(hazard.ira_likelihood, hazard.ira_severity) }}
                                  </span>
                                </td>
                                <td style="width: 7%;" class="text-nowrap">
                                  <span [class]="utils.getSiteRiskStatusTextColor(hazard.ira_score_band ?? utils.getRiskAssessmentText(hazard.ira_likelihood, hazard.ira_severity))">
                                    {{ hazard.ira_score_band ?? utils.getRiskAssessmentText(hazard.ira_likelihood, hazard.ira_severity) }}
                                  </span>
                                </td>
                                <td style="width: 7%">
                                  <span [class]="utils.getSiteRiskStatusTextColor(hazard.rra_score_band ?? utils.getRiskAssessmentText(hazard.rra_likelihood, hazard.rra_severity))">
                                    {{ hazard.rra_score ?? utils.calculateRiskScore(hazard.rra_likelihood, hazard.rra_severity) }}
                                  </span>
                                </td>
                                <td style="width: 7%;" class="text-nowrap">
                                  <span [class]="utils.getSiteRiskStatusTextColor(hazard.rra_score_band ?? utils.getRiskAssessmentText(hazard.rra_likelihood, hazard.rra_severity))">
                                    {{ hazard.rra_score_band ?? utils.getRiskAssessmentText(hazard.rra_likelihood, hazard.rra_severity) }}
                                  </span>
                                </td>
                              </tr>
                              <tr class="text-left">
                                <td style="width: 100%" colspan="9" class="controls-back">
                                  <ng-container *ngIf="hazard?.reviewer">
                                    <div><strong>Reviewer:</strong> <span>
                                        <a (click)="onUserPublicView(hazard.reviewer.hash)" matTooltip="View User Public Profile">
                                          {{ hazard.reviewer.contact_person }}
                                        </a>
                                    </span></div><br />
                                  </ng-container>
                                  <div><strong>Description:</strong> {{ hazard.description }}</div><br />
                                  <ng-container *ngIf="hazard.controls?.length">
                                    <div *ngFor="let control of utils.jsonParse(hazard.controls); let i = index">
                                      <ng-container *ngIf="control && control?.control && control?.loc">
                                        <span style="font-weight: 500">{{ i + 1 }} - {{ control.control }}</span> <br />
                                        {{ loc_list[control.loc - 1] }}
                                      </ng-container>
                                    </div>
                                  </ng-container>
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </ng-container>

                      <ng-container *ngIf="workflow.notes?.length">
                        <table class="table table-bordered">
                          <thead class="thead-light">
                            <tr class="text-left">
                              <th scope="col" style="width: 10%">Note ID #</th>
                              <th scope="col" style="width: 60%">Note</th>
                              <th scope="col" style="width: 15%">Written By</th>
                              <th scope="col" style="width: 15%">Last Updated</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white">
                            <tr *ngFor="let note of workflow.notes" class="text-left">
                              <td style="width: 10%">{{ note.id }}</td>
                              <td style="width: 60%">{{ note.note }}</td>
                              <td style="width: 15%">
                                <span *ngIf="note.created_by_user">
                                  <a (click)="onUserPublicView(note.created_by_user.hash)"
                                     matTooltip="View User Public Profile">
                                    {{ note.created_by_user.contact_person }}
                                  </a>
                                </span>
                              </td>
                              <td style="width: 15%">{{ note.date_modified ? (( note.date_modified * 1000) | timezoneConvertMedium) : (( note.date_created * 1000) | timezoneConvertLong) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </ng-container>

                      <ng-container *ngIf="workflow.files?.length">
                        <table class="table table-bordered" style="max-width: 700px">
                          <thead class="thead-light">
                            <tr class="text-left">
                              <th scope="col" style="width: 100%">Files</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white">
                            <tr class="text-left">
                              <td style="width: 100%">
                                <app-files-list [view]="true" [files]="workflow.files"></app-files-list>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </ng-container>

                    </td>
                  </tr>
                  </tbody>
                </table>
              </ng-container>

              <h4 class="mt-5 mb-4">{{ utils.getLangTerm('ta-jsa-swms.fields.factors_heading.label', 'Factors') }}</h4>

              <ng-container *ngIf="ta_revised_view.training_qualifications">
                <table class="table table-bordered">
                  <thead class="thead-dark">
                  <tr class="text-left">
                    <th scope="col" style="width: 100%">{{ utils.getLangTerm('ta-jsa-swms.fields.training_qualifications.label', 'Training/Qualifications') }}</th>
                  </tr>
                  </thead>
                  <tbody class="bg-white">
                  <tr class="text-left">
                    <td style="width: 100%">{{ ta_revised_view.training_qualifications }}</td>
                  </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.duties">
                <table class="table table-bordered">
                  <thead class="thead-dark">
                    <tr class="text-left">
                      <th scope="col" style="width: 100%">{{ utils.getLangTerm('ta-jsa-swms.fields.duties.label', 'Duties') }}</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-left">
                      <td style="width: 100%">{{ ta_revised_view.duties }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.certificates">
                <table class="table table-bordered">
                  <thead class="thead-dark">
                    <tr class="text-left">
                      <th scope="col" style="width: 100%">{{ utils.getLangTerm('ta-jsa-swms.fields.certificates.label', 'Certificates of Competency') }}</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-left">
                      <td style="width: 100%">{{ ta_revised_view.certificates }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.emergency_arrangements">
                <table class="table table-bordered">
                  <thead class="thead-dark">
                    <tr class="text-left">
                      <th scope="col" style="width: 100%">{{ utils.getLangTerm('ta-jsa-swms.fields.emergency_arrangements.label', 'Emergency Procedures') }}</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-left">
                      <td style="width: 100%;" class="white-space-pre-wrap">{{ ta_revised_view.emergency_arrangements }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.code_of_practice">
                <table class="table table-bordered">
                  <thead class="thead-dark">
                    <tr class="text-left">
                      <th scope="col" style="width: 100%">{{ utils.getLangTerm('ta-jsa-swms.fields.code_of_practice.label', 'Code of Practice') }}</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-left">
                      <td style="width: 100%">{{ ta_revised_view.code_of_practice }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.maintenance_checks">
                <table class="table table-bordered">
                  <thead class="thead-dark">
                    <tr class="text-left">
                      <th scope="col" style="width: 100%">{{ utils.getLangTerm('ta-jsa-swms.fields.maintenance_checks.label', 'Maintenance Checks') }}</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-left">
                      <td style="width: 100%">{{ ta_revised_view.maintenance_checks }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.safety_practices">
                <table class="table table-bordered">
                  <thead class="thead-dark">
                    <tr class="text-left">
                      <th scope="col" style="width: 100%">{{ utils.getLangTerm('ta-jsa-swms.fields.safety_practices.label', 'Safety Practice') }}</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-left">
                      <td style="width: 100%">{{ ta_revised_view.safety_practices }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.assets?.length">
                <table class="table table-bordered">
                  <thead class="thead-dark">
                    <tr class="text-left">
                      <th scope="col" style="width: 10%">Asset ID #</th>
                      <th scope="col" style="width: 30%">Name</th>
                      <th scope="col" style="width: 15%">Code</th>
                      <th scope="col" style="width: 20%">Type</th>
                      <th scope="col" style="width: 15%">Status</th>
                      <th scope="col" style="width: 10%">Condition Rating</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-left" *ngFor="let asset of ta_revised_view.assets">
                      <td style="width: 10%">{{ asset.id }}</td>
                      <td style="width: 30%">{{ asset.name }}</td>
                      <td style="width: 15%">{{ asset.code }}</td>
                      <td style="width: 20%">
                        <ng-container *ngIf="asset.asset_type?.parent">
                          <small style="display: block;">
                            {{ asset.asset_type?.parent?.name || '' }}
                          </small>
                        </ng-container>
                        <mat-icon *ngIf="asset.asset_type?.parent_id" style="font-size: 16px;">subdirectory_arrow_right</mat-icon>
                        {{ asset.asset_type?.name  || '' }}
                      </td>
                      <td style="width: 15%">
                        <span [style.color]="assetsService.getStatusColor(asset.status) || null">
                          {{ assetsService.getStatusLabel(asset.status) }}
                        </span>
                      </td>
                      <td style="width: 10%">
                        <span [style.color]="assetsService.getConditionColor(asset.condition_rating) || null">
                          {{ assetsService.getConditionLabel(asset.condition_rating)  }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.ppe?.length || ta_revised_view.ppe_other">
                <table class="table table-bordered">
                  <thead class="thead-dark">
                    <tr class="text-left">
                      <th scope="col" style="width: 100%">PPE</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-left">
                      <td style="width: 100%">
                        <ng-container *ngIf="ta_revised_view.ppe?.length">
                          <ul>
                            <li *ngFor="let ppe of ta_revised_view.ppe">{{ ppe.title }}</li>
                          </ul>
                        </ng-container>
                        <ng-container *ngIf="ta_revised_view.ppe_other">
                          <h6>{{ utils.getLangTerm('ta-jsa-swms.fields.ppe_other.label', 'Other PPE') }}</h6>
                          <div class="white-space-pre-wrap">{{ ta_revised_view.ppe_other }}</div>
                        </ng-container>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.work_permits?.length || ta_revised_view.work_permits_other">
                <table class="table table-bordered">
                  <thead class="thead-dark">
                    <tr class="text-left">
                      <th scope="col" style="width: 100%">Work Permits</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-left">
                      <td style="width: 100%">
                        <ng-container *ngIf="ta_revised_view.work_permits?.length">
                          <ul>
                            <li *ngFor="let work_permit of ta_revised_view.work_permits">{{ work_permit.title }}</li>
                          </ul>
                        </ng-container>
                        <ng-container *ngIf="ta_revised_view.work_permits_other">
                          <h6>{{ utils.getLangTerm('ta-jsa-swms.fields.work_permits_other.label', 'Other Work Permits') }}</h6>
                          <div class="white-space-pre-wrap">{{ ta_revised_view.work_permits_other }}</div>
                        </ng-container>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.tools?.length || ta_revised_view.tools_other">
                <table class="table table-bordered">
                  <thead class="thead-dark">
                    <tr class="text-left">
                      <th scope="col" style="width: 100%">Tools</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-left">
                      <td style="width: 100%">
                        <ng-container *ngIf="ta_revised_view.tools?.length">
                          <ul>
                            <li *ngFor="let tool of ta_revised_view.tools">{{ tool.title }}</li>
                          </ul>
                        </ng-container>
                        <ng-container *ngIf="ta_revised_view.tools_other">
                          <h6>{{ utils.getLangTerm('ta-jsa-swms.fields.tools_other.label', 'Other Tools') }}</h6>
                          <div class="white-space-pre-wrap">{{ ta_revised_view.tools_other }}</div>
                        </ng-container>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.hazardous_substances?.length">
                <h4 class="mt-5 mb-4">{{ utils.getLangTerm('hazardous-substances.plural', 'Hazardous Substances') }}</h4>

                <table class="table table-bordered">
                  <thead class="thead-dark">
                    <tr class="text-left">
                      <th scope="col">{{ utils.getLangTerm('hazardous-substances.singular', 'Hazardous Substance') }}</th>
                      <th scope="col">Classification</th>
                      <th scope="col">Risk / Related Harm</th>
                      <th scope="col">Precautions for Use</th>
                      <th scope="col">PPE</th>
                      <th scope="col">SDS</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr class="text-left" *ngFor="let hs of ta_revised_view.hazardous_substances">
                      <td>
                        <strong>{{ hs.substance }}</strong>
                      </td>
                      <td>
                        {{ hs.hazardous_substance_type || hs.un_classification || hs.hsno_classification }}
                      </td>
                      <td style="white-space: pre-wrap;">
                        {{ hs.risk_info || '' }}
                      </td>
                      <td style="white-space: pre-wrap;">
                        {{ hs.additional_info || '' }}
                      </td>
                      <td>
                        <ng-container *ngIf="hs.ppe?.length; else noPpe">
                          <div *ngFor="let p of hs.ppe">
                            <span>{{ p.title }}</span>
                          </div>
                        </ng-container>
                        <ng-template #noPpe>
                          <span class="text-muted">None specified</span>
                        </ng-template>
                      </td>
                      <td>
                        <ng-container *ngIf="hs.files?.length; else noSds">
                          <div *ngFor="let file of hs.files" class="mb-2">
                            <div class="mb-0"><small>{{ file.name }}</small></div>
                            <div>
                              <button
                                mat-icon-button
                                ngxClipboard
                                [cbContent]="file.url"
                                (cbOnSuccess)="utils.showToast('The URL is copied to your clipboard.')"
                                matTooltip="Copy file URL to clipboard."
                                style="cursor: pointer;">
                                <mat-icon>content_copy</mat-icon>
                              </button>
                              <button
                                mat-icon-button
                                matTooltip="Download the file."
                                (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)"
                                style="cursor: pointer;">
                                <mat-icon>download</mat-icon>
                              </button>
                              <button
                                mat-icon-button
                                matTooltip="View the file."
                                (click)="utils.openUrl(file.url)"
                                style="cursor: pointer;">
                                <mat-icon>preview</mat-icon>
                              </button>
                            </div>
                          </div>
                        </ng-container>
                        <ng-template #noSds>
                          <span class="text-muted">None available</span>
                        </ng-template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-container *ngIf="ta_revised_view.users?.length">
                <h4 class="mt-5 mb-4">Assignees</h4>

                <table class="table table-bordered">
                  <thead class="thead-dark">
                    <tr class="text-left">
                      <th scope="col" style="width: 10%">User ID #</th>
                      <th scope="col" style="width: 35%">Company</th>
                      <th scope="col" style="width: 15%">Assignee</th>
                      <th scope="col" style="width: 12%">Acknowledged</th>
                      <th scope="col" style="width: 15%">Assignee Signature</th>
                      <th scope="col" style="width: 15%">Acknowledged Date</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr *ngFor="let user of ta_revised_view.users" class="text-left">
                      <td style="width: 10%">{{ user.id }}</td>
                      <td style="width: 45%">
                        <div *ngFor="let account of user.accounts">
                          <span *ngIf="account.id == user.account_id">{{ account.name }}</span>
                        </div>
                      </td>
                      <td style="width: 15%">
                        <a (click)="onUserPublicView(user.hash)"
                          matTooltip="View User Public Profile">
                          {{ user.contact_person }}
                        </a>
                      </td>
                      <td style="width: 15%">
                        <span *ngIf="user.pivot.acknowledged" style="color: green">Yes</span>
                        <span *ngIf="!user.pivot.acknowledged" style="color: red">No</span>
                      </td>
                      <td style="width: 15%" >
                        <img *ngIf="user.pivot.acknowledged_signature_url" style="width: 100px" [src]="user.pivot.acknowledged_signature_url" [alt]="'Signature of ' + user.contact_person" class="uploaded-image" />
                      </td>
                      <td style="width: 15%">{{ user.pivot.acknowledged_date ? (( user.pivot.acknowledged_date * 1000) | timezoneConvertMedium) : '' }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

            </div>
          </div>
        </div>

      </div>

    </div>
  </div>

</div>
